module.exports = __webpack_public_path__ + "img/show3.69d6157d.jpg";